import { memo, useEffect, useRef, useState } from 'react';
import { SharedState } from '../sharedState/SharedState';
import { buildFromHtmlSource } from '../component-lists/helpers';
import { useLocation } from 'react-router-dom';
import { isEqual } from 'lodash';
import { loadCart } from '../utils/cart.utils';

/***
 * This is the top level component that renders the entire site.
 */
export const SiteRoot = memo(function SiteRoot(props: {
  indexcontent: string,
  state: SharedState,
}) {

  const useLocationOnClient = props.state.isClient ? useLocation : () => { return { search: "" } };
  const location = useLocationOnClient();

  const [inIframe, setInIframe] = useState<boolean>(false);

  /***
   * Find out if the site is embedded in an iframe.
   * This is used to apply different styles to the site when it is embedded.
   * Run this as an effect so it can run on the client only.
   */
  useEffect(() => {
    if (props.state.isClient) {
      setInIframe(window.self !== window.top);
    }
  }, [props.state.isClient]);

  const stateRef = useRef<SharedState>(props.state);

  if (props.state.isClient) {
    const nextState = props.state.clone();
    // Update the state from the query string
    nextState.updateFromQuery(decodeURI(location.search), props.state.settings);

    // Add cart to settings
    nextState.cart = loadCart(props.state.site?.name || "unknown");

    if (!isEqual(nextState, stateRef.current)) {
      stateRef.current = nextState;
    }

  }

  const content = buildFromHtmlSource(props.indexcontent, stateRef.current);

  return <div
    id={"__scdp_siteroot_component"}
    className={"_site _slot-" + (props.state.filters.slot || "production") + (inIframe ? " embedded" : " standalone")}>
    {content || ""}
  </div>
});